import IAdmissionRepository from "../4_Repositories/IAdmissionRepository";

export default class PostStartUseCase {
  private readonly _repository: IAdmissionRepository;

  constructor(repository: IAdmissionRepository) {
    this._repository = repository;
  }

  public async execute(admissionExamId: string, quizzesId: string) {
    const entities = await this._repository.postStart(
      admissionExamId,
      quizzesId
    );

    return entities;
  }
}
